/* eslint-disable jsx-a11y/label-has-associated-control */
import { isArray, isObject } from 'lodash';
import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { CurrentYearItemRenderer } from '../CurrentYearDropdown';

function CommonMultiSelect({
  label,
  index,
  onChange,
  selectedValue,
  optionList,
  selectLabel,
  dataPlaceholder,
  selectValue,
  disable,
  required,
  className,
  fromUser,
  optionListData,
  scrollToCurrentYear,
}) {
  let isOptionObjectType = false;
  if (isArray(selectedValue) && isObject(selectedValue[0])) {
    isOptionObjectType = true;
  }
  // Build options, ensuring selected items (even if missing/inactive in optionList) are included
  const baseOptions = (fromUser ? optionListData : optionList) || [];
  let optionsToRender = baseOptions;
  if (isArray(selectedValue)) {
    const selectedObjs = selectedValue?.filter((sv) => isObject(sv));
    if (selectedObjs?.length) {
      const missing = selectedObjs.filter((sv) => !baseOptions?.some((opt) => opt?.[selectValue] === sv?.[selectValue]));
      if (missing?.length) {
        optionsToRender = [...baseOptions, ...missing];
      }
    }
  }

  return (
    <div>
      <label htmlFor="admin" className={` ${className} select-label asterisk-req mb-0`}>
        {label}
        {required && <span>*</span>}
      </label>
      <MultiSelect
        name={label}
        key={`${label}_${index}`}
        options={(optionsToRender || [])?.map((e) => {
          e.label = e?.[selectLabel];
          e.value = e?.[selectValue];
          return e;
        })}
        className="product-custom-multiselect common-new-multiselect w-100"
        value={(optionsToRender || [])?.filter((element) => {
          if (isOptionObjectType) {
            const find = (selectedValue || [])?.find((valFind) => valFind[selectValue] === element[selectValue]);
            return !!find;
          }
          return (selectedValue || [])?.includes(element?.[selectValue]);
        })}
        overrideStrings={{
          selectSomeItems: dataPlaceholder ? `Select ${dataPlaceholder}` : `Select ${label}`,
        }}
        labelledBy={dataPlaceholder ? `Select ${dataPlaceholder}` : `Select ${label}`}
        disabled={disable}
        ItemRenderer={scrollToCurrentYear ? CurrentYearItemRenderer : undefined}
        onChange={(selected) =>
          onChange(
            selected.map((e) => e?.[selectValue]),
            label,
            index,
          )
        }
      />
    </div>
  );
}

export default CommonMultiSelect;
